import { render, staticRenderFns } from "./formInputMultiple.vue?vue&type=template&id=64bc5b8e"
import script from "./formInputMultiple.vue?vue&type=script&lang=js"
export * from "./formInputMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports